import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const SolicitarFeriasCivilService = {
  async postFerias(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      "civil/ferias",
      postData,
    );

    if (response.error) {
      SnackBarModule(response.message.error, "error");
      return false;
    }

    const msg = await response.message;
    SnackBarModule(msg.msg, "success");
    return true;
  },

  async postFeriasPremio(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      "civil/ferias/premio",
      postData,
    );
    if (response.error) {
      SnackBarModule(response.message, "error");
      return false;
    }

    SnackBarModule('Férias solicitadas com sucesso', "success");
    return true;
  },

  async postFeriasVantagem(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      "civil/ferias/vantagem",
      postData,
    );
    if (response.error) {
      SnackBarModule(response.message, "error");
      return false;
    }

    SnackBarModule('Férias movidas para vantagem', "success");
    return true;
  },

  async pegarDiasRestantes(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      "civil/ferias/diasRestantes",
      postData
    );
    if (response.error) {
      SnackBarModule(response.message, "error");
      return false;
    }

    return await response.message;
  },

  async calcularDiasUteis(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      "calcula",
      postData,
    );
    return response.message;
  },

  async verificarFeriasCassadas(exercicio) {
    const formData = new FormData();
    formData.append('exercicio', exercicio);
    
    const response = await BaseService.fetchResponseFromAPIPost(
      "civil/ferias/verificar-cassadas",
      formData
    );
    
    if (response.error) {
      SnackBarModule(response.message, "error");
      return false;
    }

    return response.message;
  },
};